import {MemberFirmVisitorVisaTypeEnum, MemberFirmVisitorVisitReasonEnum} from '@employee-models/data.enums';

export const VISIT_REASON: Array<{ name: string, id: MemberFirmVisitorVisitReasonEnum }> = [
    {
        name: 'Deliver / Attend Internal Training',
        id: MemberFirmVisitorVisitReasonEnum.DeliverAttendInternalTrainings
    },
    {
        name: 'External Client Meetings',
        id: MemberFirmVisitorVisitReasonEnum.ExternalClientMeetings
    },
    {
        name: 'Internal Team Meetings',
        id: MemberFirmVisitorVisitReasonEnum.InternalTeamMeetings
    },
    {
        name: 'Participate in External Trainings',
        id: MemberFirmVisitorVisitReasonEnum.ParticipateInExternalTrainings
    },
    {
        name: 'Perform Client Billable Work',
        id: MemberFirmVisitorVisitReasonEnum.PerformClientBillableWork
    },
    {
        name: 'Seminars or Conferences',
        id: MemberFirmVisitorVisitReasonEnum.SeminarsOrConferences
    },
    {
        name: 'Supervising Client Billable Work',
        id: MemberFirmVisitorVisitReasonEnum.SupervisingClientBillableWork
    },
];
